class CreateAccount {
    constructor() {
        new bootstrap.Modal(document.getElementById('kt_modal_create_account'),{
            backdrop: 'static',
            keyboard: false
        }).show();
        this.selectAvatarEvent();
        var element = document.querySelector("#kt_modal_create_account_stepper");
        var startIndex = element.getAttribute('starting-step');
        const stepper = new KTStepper(element, {
            startIndex: startIndex
        });

        stepper.on("kt.stepper.next", function (stepper) {


            stepper.goNext(); // go next step
        });
        stepper.on("kt.stepper.previous", function (stepper) {
            stepper.goPrevious(); // go previous step
        });
        this.createAccountForm(stepper);
        this.chooseAvatarAccountForm(stepper);
        this.registerTwoStepForm(stepper);
        this.stepperLinkEvents(stepper);
        this.finishWizard();
    }

    stepperLinkEvents(stepper){
        $('.stepper-link').click(function () {
            window.open($(this).attr('href'), '_blank');
        });
        $('#save-download-button').click(function () {
            stepper.goNext();
        });
    }
    selectAvatarEvent(){
        $('.choosable-avatar').click(function () {
            let value = $(this).attr('value');
            $('#chosen-account-avatar').attr('src','/media/goodaccess/avatars/svg/Icon with face-'+value);
            $('#chosen-account-avatar-input').val(value);
        });
    }

    chooseAvatarAccountForm(stepper){
        let submitButton = document.getElementById('save-account-avatar');
        submitButton.addEventListener('click', function (e) {
            e.preventDefault();
            submitButton.setAttribute('data-kt-indicator', 'on');
            submitButton.disabled = true;
            $('#frm-createAccountForm-chooseAvatarForm').submit();
        });

        $.nette.ext('chooseAvatarForm', {
            success: function (payload, status, jqXHR, settings) {
                let formID = settings.nette.form[0].attributes.id.value;
                if(formID === 'frm-createAccountForm-chooseAvatarForm'){
                    if(payload['avatarSet']){
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                        stepper.goNext();
                    }
                }
            }
        });
    }

    finishWizard(){
        let form = document.getElementById('frm-createAccountForm-finishWizardForm');
        if(form){
            let submitButton = document.getElementById('finish-wizard-form');
            submitButton.addEventListener('click', function (e) {
                e.preventDefault();
                submitButton.setAttribute('data-kt-indicator', 'on');
                submitButton.disabled = true;
                $('#frm-createAccountForm-finishWizardForm').submit();
            });

            $.nette.ext('finishWizardForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-createAccountForm-finishWizardForm'){
                        submitButton.setAttribute('data-kt-indicator', 'off');
                        submitButton.disabled = false;
                    }
                }
            });
        }
    }

    registerTwoStepForm(stepper){
        let form = document.getElementById('frm-createAccountForm-registerTwoStepForm');
        if(form){
            let submitButton = document.getElementById('save-two-step');
            if(form){
                new MfaInputEvents(form);

                submitButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    submitButton.setAttribute('data-kt-indicator', 'on');
                    submitButton.disabled = true;
                    $('#frm-createAccountForm-registerTwoStepForm').submit();
                });

                $.nette.ext('twoStepForm', {
                    success: function (payload, status, jqXHR, settings) {
                        let formID = settings.nette.form[0].attributes.id.value;
                        if(formID === 'frm-createAccountForm-registerTwoStepForm'){
                            if(payload['twoStepSet']){
                                stepper.goNext();
                            }
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            submitButton.disabled = false;
                        }
                    }
                });
            }
        }
    }
    createAccountForm(stepper){
        Inputmask("", {
            "numericInput": true
        }).mask(".two-fa-input");
        let form = document.getElementById('frm-createAccountForm-createAccountForm');
        if(form){
            let submitButton = document.getElementById('save-account-details');
            let passwordMeter = KTPasswordMeter.getInstance(form.querySelector('[data-kt-password-meter="true"]'));
            const validatePassword = function() {

                return (passwordMeter.getScore() === 100);
            };
            const fvCreateAccount = FormValidation.formValidation(
                form,
                {
                    fields: {
                        'firstname': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required',
                                },
                                stringLength: {
                                    max: 64,
                                    message: 'First name cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                        'lastname': {
                            validators: {
                                stringLength: {
                                    max: 64,
                                    message: 'Last name cannot be over 64 characters',
                                },
                                regexp: {
                                    regexp: /^[a-zA-ZáčďéěíňóřšťůúýžÁČĎÉĚÍŇÓŘŠŤŮÚÝŽ0-9' _.-]*$/,
                                    message: 'Only these special characters are allowed. (_.-)',
                                },
                            }
                        },
                        'password': {
                            validators: {
                                notEmpty: {
                                    message: 'This field is required'
                                },
                                stringLength: {
                                    max: 45,
                                    message: 'Password has to be between 8 and 45 characters long',
                                },
                                regexp: {
                                    regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.])[A-Za-z\d[~`!#@$%\^&*+=\-\[\]\\\';,\/{}|\\":<>\?()§_´¨.]{8,45}$/,
                                    message: '',
                                },
                                callback: {
                                    message: 'Please enter valid password',
                                    callback: function() {
                                        return validatePassword();
                                    }
                                }
                            }
                        }
                    },
                    plugins: {
                        trigger: new FormValidation.plugins.Trigger(),
                        autoFocus: new FormValidation.plugins.AutoFocus(),
                        submitButton: new FormValidation.plugins.SubmitButton(),
                        //defaultSubmit: new FormValidation.plugins.DefaultSubmit()
                        bootstrap: new FormValidation.plugins.Bootstrap5({
                            rowSelector: '.form-validation-marker',
                            eleInvalidClass: '',
                            eleValidClass: ''
                        }),
                        icon: new FormValidation.plugins.Icon({
                            valid: 'fa fa-check',
                            invalid: 'fa fa-times',
                            validating: 'fa fa-refresh',
                        }),
                    }
                }
            ).on('core.element.validated', function(e) {
                if(e.element.attributes.name.value === 'password'){
                    // Get the icon plugin instance
                    const iconPlugin = fvCreateAccount.getPlugin('icon');
                    const iconElement = iconPlugin && iconPlugin.icons.has(e.element) ? iconPlugin.icons.get(e.element) : null;
                    // Hide the icon
                    iconElement && (iconElement.style.display = 'none');
                }
            });
            submitButton.addEventListener('click', function (e) {
                // Prevent default button action
                e.preventDefault();
                fvCreateAccount.validate().then(function(status) {
                    if(status === 'Valid'){
                        submitButton.setAttribute('data-kt-indicator', 'on');
                        submitButton.disabled = true;
                        $('#frm-createAccountForm-createAccountForm').submit();
                    }else {
                        return;
                    }
                });
            });

            $.nette.ext('createAccountForm', {
                success: function (payload, status, jqXHR, settings) {
                    let formID = settings.nette.form[0].attributes.id.value;
                    if(formID === 'frm-createAccountForm-createAccountForm'){
                        if(payload['accountCreated']){
                            submitButton.setAttribute('data-kt-indicator', 'off');
                            submitButton.disabled = false;
                            stepper.goNext();
                        }
                    }
                }
            });
        }
    }
}
window.CreateAccount = CreateAccount;
